"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const restore_1 = require("../../../app/dist/restore");
exports.toolDef = {
    name: 'loom_restore',
    description: "Restore an archived Loom item from loom/.archive/ back to loom/ (inverse of loom_archive). Restore a thread/weave folder by { weaveId, threadId? }, or a single archived doc by { archivedRelPath } (its path relative to loom/.archive/, e.g. 'core-engine/foo/plans/x.md'). Empty archive container dirs are pruned. Use this tool — do not move files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            weaveId: { type: 'string', description: 'Weave to restore (whole folder), or the weave of the thread to restore' },
            threadId: { type: 'string', description: 'Thread to restore (requires weaveId)' },
            archivedRelPath: { type: 'string', description: "A single doc's path relative to loom/.archive/ (mutually exclusive with weaveId)" },
        },
        required: [],
    },
};
async function handle(root, args) {
    const weaveId = args['weaveId'];
    const threadId = args['threadId'];
    const archivedRelPath = args['archivedRelPath'];
    const input = weaveId
        ? { weaveId, threadId }
        : { archivedRelPath: archivedRelPath };
    const result = await (0, restore_1.restoreItem)(input, {
        getActiveLoomRoot: () => root,
        fs,
        // (loomRoot resolution: the tool's `root` is already the active loom root)
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
